import React from "react";
import { useTheme } from "../context/ThemeContext";

function Statistics({ initialDeposit, calculateCurrentBalance }) {
  const { darkMode } = useTheme();
  const currentBalance = calculateCurrentBalance();
  const profitLoss = currentBalance - initialDeposit;
  const percentageChange = ((profitLoss / initialDeposit) * 100).toFixed(2);

  return (
    <div
      className={`${
        darkMode ? "bg-gray-800" : "bg-white"
      } p-6 rounded-lg shadow-md`}
    >
      <h2
        className={`text-xl font-semibold mb-6 ${
          darkMode ? "text-white" : "text-gray-800"
        }`}
      >
        Backtest Results
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        <div>
          <p className={`${darkMode ? "text-gray-300" : "text-gray-600"}`}>
            Initial Deposit
          </p>
          <p
            className={`text-2xl font-bold ${
              darkMode ? "text-white" : "text-gray-900"
            }`}
          >
            ${initialDeposit.toFixed(2)}
          </p>
        </div>
        <div>
          <p className={`${darkMode ? "text-gray-300" : "text-gray-600"}`}>
            Final Balance
          </p>
          <p
            className={`text-2xl font-bold ${
              darkMode ? "text-white" : "text-gray-900"
            }`}
          >
            ${currentBalance.toFixed(2)}
          </p>
        </div>
        <div>
          <p className={`${darkMode ? "text-gray-300" : "text-gray-600"}`}>
            Profit/Loss
          </p>
          <p
            className={`text-2xl font-bold ${
              profitLoss >= 0 ? "text-green-500" : "text-red-500"
            }`}
          >
            ${profitLoss.toFixed(2)}
          </p>
        </div>
        <div>
          <p className={`${darkMode ? "text-gray-300" : "text-gray-600"}`}>
            Return
          </p>
          <p
            className={`text-2xl font-bold ${
              profitLoss >= 0 ? "text-green-500" : "text-red-500"
            }`}
          >
            {percentageChange}%
          </p>
        </div>
      </div>
    </div>
  );
}

export default Statistics;
